import { render, staticRenderFns } from "./onJob.vue?vue&type=template&id=11806570&scoped=true"
import script from "./onJob.vue?vue&type=script&lang=js"
export * from "./onJob.vue?vue&type=script&lang=js"
import style0 from "./onJob.vue?vue&type=style&index=0&id=11806570&prod&scoped=true&lang=css"
import style1 from "./onJob.vue?vue&type=style&index=1&id=11806570&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11806570",
  null
  
)

export default component.exports